import React, { FC } from 'react';

import s from './FallbackImage.module.scss';

export type FallbackImageProps = {
  alt: string;
};

const FallbackImage: FC<FallbackImageProps> = ({ alt }) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      data-testid="fallbackimage"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 313.03 277.95"
      role="img"
      className={s.fallbackImage}
    >
      <title>{alt}</title>
      <desc>Photo Cooming soon (Our Photo Team is on it!)</desc>
      <path
        className={s['cls-1']}
        d="M134.32,76H106.91V133h11.26V113.87h16.52s14.64-3.76,14.64-19.9S134.32,76,134.32,76Zm-2.44,29.28H117.61V85.53h15.2s6.57,1.68,6.57,9.85A10,10,0,0,1,131.88,105.23Z"
        transform="translate(-78.07 -74.45)"
      />
      <polygon
        className={s['cls-1']}
        points="76.7 1.5 76.7 58.57 87.4 58.57 87.4 32.66 111.99 32.66 111.99 58.57 123.07 58.57 123.07 1.5 112.37 1.5 112.37 22.59 87.03 22.59 87.03 1.5 76.7 1.5"
      />
      <path
        className={s['cls-1']}
        d="M233.8,74.45s-27.4-.19-27.4,29.84S234.69,134,234.69,134s28.3-.21,28.3-30.34S233.8,74.45,233.8,74.45Zm.89,49.93s-16.52.24-16.52-20.12,16-20.23,16-20.23,17-.64,17,19.78S234.69,124.38,234.69,124.38Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M166.79,154.79s-27.41-.19-27.41,29.84,28.3,29.69,28.3,29.69S196,214.1,196,184,166.79,154.79,166.79,154.79Zm.89,49.93s-16.52.23-16.52-20.12,16-20.24,16-20.24,17-.63,17,19.79S167.68,204.72,167.68,204.72Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M200.25,234.25s-27.41-.19-27.41,29.84,28.3,29.69,28.3,29.69,28.3-.21,28.3-30.34S200.25,234.25,200.25,234.25Zm.89,49.93s-16.52.23-16.52-20.12,16-20.23,16-20.23,17-.64,17,19.78S201.14,284.18,201.14,284.18Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M261.1,234.25s-27.41-.19-27.41,29.84S262,293.78,262,293.78s28.3-.21,28.3-30.34S261.1,234.25,261.1,234.25Zm.89,49.93s-16.52.23-16.52-20.12,16-20.23,16-20.23,17-.64,17,19.78S262,284.18,262,284.18Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M334,74.72s-27.41-.19-27.41,29.84,28.3,29.69,28.3,29.69,28.29-.21,28.29-30.34S334,74.72,334,74.72Zm.89,49.93s-16.52.24-16.52-20.12,16-20.23,16-20.23,17-.64,17,19.78S334.93,124.65,334.93,124.65Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M100.85,334s-7.5-.05-7.5,8.22,7.74,8.17,7.74,8.17,7.75-.06,7.75-8.35S100.85,334,100.85,334Zm.24,13.75s-4.52.06-4.52-5.54,4.38-5.57,4.38-5.57,4.66-.18,4.66,5.44S101.09,347.74,101.09,347.74Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M208.64,334s-7.5-.05-7.5,8.22,7.74,8.17,7.74,8.17,7.75-.06,7.75-8.35S208.64,334,208.64,334Zm.24,13.75s-4.52.06-4.52-5.54,4.38-5.57,4.38-5.57,4.66-.18,4.66,5.44S208.88,347.74,208.88,347.74Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M324.43,334s-7.5-.05-7.5,8.22,7.74,8.17,7.74,8.17,7.74-.06,7.74-8.35S324.43,334,324.43,334Zm.24,13.75s-4.52.06-4.52-5.54,4.38-5.57,4.38-5.57,4.66-.17,4.66,5.45S324.67,347.73,324.67,347.73Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M181.33,334s-7.5-.05-7.5,8.21,7.74,8.18,7.74,8.18,7.74-.06,7.74-8.36S181.33,334,181.33,334Zm.24,13.74s-4.52.07-4.52-5.54,4.38-5.57,4.38-5.57,4.66-.17,4.66,5.45S181.57,347.73,181.57,347.73Z"
        transform="translate(-78.07 -74.45)"
      />
      <polygon
        className={s['cls-1']}
        points="200.03 58.57 200.03 10.89 184.92 10.89 184.92 1.5 227.62 1.5 227.62 10.7 212.54 10.7 212.54 58.57 200.03 58.57"
      />
      <path
        className={s['cls-1']}
        d="M153.7,333.76h-7.46v16.15h3.06v-5.42h4.5a5.69,5.69,0,0,0,4-5.63A4.88,4.88,0,0,0,153.7,333.76Zm-.67,8.29h-3.88v-5.58h4.14a2.7,2.7,0,0,1,1.79,2.79A2.79,2.79,0,0,1,153,342.05Z"
        transform="translate(-78.07 -74.45)"
      />
      <polygon
        className={s['cls-1']}
        points="81.2 259.32 81.2 275.46 84.11 275.46 84.11 268.13 90.8 268.13 90.8 275.46 93.82 275.46 93.82 259.32 90.91 259.32 90.91 265.28 84.01 265.28 84.01 259.32 81.2 259.32"
      />
      <polygon
        className={s['cls-1']}
        points="151.32 275.46 151.32 261.97 147.2 261.97 147.2 259.32 158.83 259.32 158.83 261.92 154.95 261.92 154.95 275.46 151.32 275.46"
      />
      <polygon
        className={s['cls-1']}
        points="115.46 275.81 115.46 262.32 111.34 262.32 111.34 259.67 122.97 259.67 122.97 262.27 119.09 262.27 119.09 275.81 115.46 275.81"
      />
      <polygon
        className={s['cls-1']}
        points="287.37 275.46 287.37 262.06 283.26 262.06 283.26 259.42 294.88 259.42 294.88 262.01 291.01 262.01 291.01 275.46 287.37 275.46"
      />
      <path
        className={s['cls-1']}
        d="M124.18,174.5l11.07-3s-3.56-17.7-23.65-17.7S84,169.05,84.2,182.38s5.81,31.94,25.53,31.94,26.46-17.6,26.46-17.6l-10.13-4.58s-3.57,11.58-15,11.58-15.39-10.45-15.39-19.18,2.63-21.12,15.77-21.12S124.18,174.5,124.18,174.5Z"
        transform="translate(-78.07 -74.45)"
      />
      <polygon
        className={s['cls-1']}
        points="121.57 138.34 121.57 81.28 137.33 81.28 148.41 122.28 160.05 81.28 175.44 81.28 175.44 138.34 165.12 138.34 165.12 92.54 153.66 138.34 144.09 138.34 131.7 92.92 131.7 138.34 121.57 138.34"
      />
      <polygon
        className={s['cls-1']}
        points="187.92 275.84 187.92 259.54 192.32 259.54 195.4 271.25 198.65 259.54 202.94 259.54 202.94 275.84 200.06 275.84 200.06 262.76 196.87 275.84 194.2 275.84 190.75 262.87 190.75 275.84 187.92 275.84"
      />
      <rect
        className={s['cls-1']}
        x="182.57"
        y="81.28"
        width="10.7"
        height="57.06"
      />
      <rect
        className={s['cls-1']}
        x="212.21"
        y="259.54"
        width="2.67"
        height="16.39"
      />
      <rect
        className={s['cls-1']}
        x="277.96"
        y="259.54"
        width="2.67"
        height="16.39"
      />
      <polygon
        className={s['cls-1']}
        points="199.47 81.28 199.47 138.34 210.73 138.34 210.73 98.92 234.94 138.34 244.14 138.34 244.14 81.28 234.19 81.28 234.19 120.7 209.23 81.28 199.47 81.28"
      />
      <polygon
        className={s['cls-1']}
        points="218 161.32 218 218.38 229.26 218.38 229.26 178.96 253.48 218.38 262.68 218.38 262.68 161.32 252.73 161.32 252.73 200.74 227.76 161.32 218 161.32"
      />
      <polygon
        className={s['cls-1']}
        points="256.29 259.54 256.29 275.84 259.35 275.84 259.35 264.58 265.91 275.84 268.4 275.84 268.4 259.54 265.7 259.54 265.7 270.8 258.94 259.54 256.29 259.54"
      />
      <path
        className={s['cls-1']}
        d="M370.08,191.2H355.81v-9.57h24v31.16H371.2V208.1a21.66,21.66,0,0,1-15.39,6c-9.95,0-27.78-5.25-27.78-29.84s18.58-30.41,27.59-30.41,20.84,4.88,24.22,17.08l-9.58,4.69s-3-12.57-15-12.57-15.77,12-15.77,21.21S342.86,204,355.43,204,370.08,191.2,370.08,191.2Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M140.32,283c-3.22-.44-7.32-2.06-10.51-7.69l-8.63,6.38s8.43,12.59,20.32,13.49c3.19.18,3.56.18,8.31.16,6.12,0,21.48-3.89,21.48-19.09S153.46,259,153.46,259s-18.21-.75-18.21-9,11.64-6.14,11.64-6.14,9.58.88,14.46,7.83l9-6.2s-6.39-12.2-23.09-12.2-23.09,10.51-23.09,18.4,3.63,11.93,7.88,13.89c6.13,2.81,16.3,2.87,21.19,3.94,2.87.62,6,1.5,6,7.13s-4.13,6.25-6.38,6.38A85.2,85.2,0,0,1,140.32,283Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M300.22,347a3.81,3.81,0,0,1-2.9-2L295,346.7s2.32,3.3,5.59,3.54c.88.05,1,.05,2.29,0,1.68,0,5.91-1,5.91-5s-4.91-4.53-4.91-4.53-5-.2-5-2.37,3.21-1.61,3.21-1.61a6.09,6.09,0,0,1,4,2.06l2.48-1.63a7.17,7.17,0,0,0-6.35-3.2c-4.6,0-6.36,2.76-6.36,4.83a3.61,3.61,0,0,0,2.17,3.64c1.69.74,4.49.76,5.84,1,.78.16,1.66.39,1.66,1.87S304.3,347,303.68,347A23.51,23.51,0,0,1,300.22,347Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M110.1,334h2.82v11.37a3.36,3.36,0,0,0,3.1,2.37,4.64,4.64,0,0,0,3.66-2V334h2.95v13.74a8.74,8.74,0,0,1-12.53,0Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M136.57,338.11a3.88,3.88,0,0,0-4.25-4.12h-7.58v16.3h3.1V343.6h2.32l3.87,6.31h2.54l-3.73-6.73A4.8,4.8,0,0,0,136.57,338.11Zm-9.22,3.67V336h5a3.85,3.85,0,0,1,1.54,2.9,3.9,3.9,0,0,1-1.4,2.89Z"
        transform="translate(-78.07 -74.45)"
      />
      <polygon
        className={s['cls-1']}
        points="160.14 259.54 160.14 275.81 171.97 275.81 171.97 272.55 162.96 272.55 162.96 268.33 170.56 268.33 170.56 265.7 163.14 265.7 163.14 262.18 171.4 262.18 171.4 259.54 160.14 259.54"
      />
      <path
        className={s['cls-1']}
        d="M259,333.67h-2.54l-5.35,16.58h2.54l1.05-3.49h6.2l1.19,3.49h2.61Zm-3.8,10.75,2.71-7.56,2.42,7.56Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M375.12,345.57a91,91,0,0,1-1.27-11,1.74,1.74,0,0,1,1.55-.6c1.2,0,1.55.6,1.55.6l-1,11Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M375.4,346.7a1.67,1.67,0,0,1,1.55,1.76c0,1.26-1.55,1.83-1.55,1.83s-1.83-.22-1.83-1.8A1.61,1.61,0,0,1,375.4,346.7Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M385,332.48s6.13,2.84,6.13,9.41S385,352.4,385,352.4A20.35,20.35,0,0,0,388,341.89,14.68,14.68,0,0,0,385,332.48Z"
        transform="translate(-78.07 -74.45)"
      />
      <path
        className={s['cls-1']}
        d="M84.2,352.1s-6.13-2.84-6.13-9.41,6.13-10.51,6.13-10.51a20.35,20.35,0,0,0-3.07,10.51A14.68,14.68,0,0,0,84.2,352.1Z"
        transform="translate(-78.07 -74.45)"
      />
    </svg>
  );
};

export default FallbackImage;
